import styles from './growthSection.scss';
import DownloadBlack from '../../common/downloadBlack';
import { Component } from 'react';
import { Api } from '../../../api';
import { GrowthIconDesktop } from './icon/growthIconDesktop';
import { GrowthIconMobile } from './icon/growthIconMobile';
// import { MoneyIconGreen } from './icon/moneyIconGreen';
// import { MoneyIcon } from './icon/moneyIcon';

const api = new Api();

export class GrowthSection extends Component {
  constructor(props: any) {
    super(props);
    this.state = {
      isInputOpen: false,
    };
  }
  private changeClassName = (value: boolean) => {
    this.setState({
      isInputOpen: value,
    });
  };

  public async sendBlackSMS(phone: string) {
    const returnVal = await api.sendBlackSMS(phone);
    await api.recordBlackSMSSheet(phone);
    return returnVal;
  }
  public render() {
    return (
      <div className="lil-container">
        <div className={`lil-flex lil-relative ${styles['wealthSection']}`}>
          <div className="lil-py-16 sm:lil-py-0 lil-w-3/5 sm:lil-text-center sm:lil-w-full">
            <h1 className={`lil-py-2 lil-text-s-56 sm:lil-text-s-32`}>
              Mutual Funds
            </h1>
            <div className="lil-flex lil-py-6 sm:lil-justify-center lil-flex-col">
              <div className="lil-flex lil-pt-4 lil-items-center sm:lil-items-start">
                <div className="lil-tick-wrapper">
                  <div className="lil-tick"></div>
                </div>
                <p className="lil-px-2 lg:lil-text-s-18 sm:lil-w-5/6 hero-line lil-text-left">
                  Mutual fund investment at 0% commission{' '}
                </p>
              </div>
              <div className="lil-flex lil-pt-4 lil-items-center sm:lil-items-start sm:lil-pt-2">
                <div className="lil-tick-wrapper">
                  <div className="lil-tick"></div>
                </div>
                <p className="lil-px-2 lg:lil-text-s-18 sm:lil-w-5/6 hero-line lil-text-left">
                  Earn 1.5% extra returns through direct mutual funds
                </p>
              </div>
              <div className="lil-flex lil-pt-4 lil-items-center sm:lil-items-start sm:lil-pt-2">
                <div className="lil-tick-wrapper">
                  <div className="lil-tick"></div>
                </div>
                <p className="lil-px-2 lg:lil-text-s-18 sm:lil-w-5/6 hero-line lil-text-left">
                  Invest in mutual fund plans curated by experts
                </p>
              </div>
              <div className="lil-flex lil-pt-4 lil-items-center sm:lil-items-start sm:lil-pt-2">
                <div className="lil-tick-wrapper">
                  <div className="lil-tick"></div>
                </div>
                <p className="lil-px-2 lg:lil-text-s-18 sm:lil-w-5/6 hero-line lil-text-left">
                  Trusted by 25 lakh Indians
                </p>
              </div>
              {/*  <div className="lil-flex lil-items-center lil-mr-12 sm:lil-flex-col sm:lil-justify-center">
                <div className="lil-mr-2">
                  <MoneyIcon />
                </div>
                <span className="lil-text-s-20 sm:lil-mt-2 sm:lil-text-base">
                  0% commission
                </span>
              </div>
              <div className="lil-flex lil-items-center sm:lil-flex-col ">
                <div className="lil-mr-2">
                  <MoneyIconGreen />
                </div>
                <span className="lil-text-s-20 sm:lil-mt-2 sm:lil-text-base">
                  <span className="sm:lil-hidden">Upto</span> 1.5% extra returns
                </span>
              </div> */}
            </div>
            <div className="xl:lil-hidden lg:lil-hidden md:lil-hidden">
              {/* <img
                src="https://assets1.cleartax-cdn.com/cleartax/images/1632907282_group18140462.png"
                alt="wealth"
              /> */}
              <GrowthIconMobile />
            </div>
            <div className="lil-flex sm:lil-flex-col sm:lil-mt-8">
              {!this.state.isInputOpen ? (
                <a
                  className="lil-btn lil-btn-blue lil-mr-4 sm:lil-mb-4"
                  href="https://cleartax.in/save/search"
                >
                  Start investing now
                </a>
              ) : null}

              <div className="sm:lil-hidden">
                <DownloadBlack
                  btnText="Download Black App"
                  onShowInput={this.changeClassName}
                  sendBlackSMS={this.sendBlackSMS}
                  btnClasses={'lil-btn-white lil-border-sm'}
                  inputWidth="250px"
                />
              </div>
              <div className="xl:lil-hidden lg:lil-hidden md:lil-hidden">
                <a
                  href="https://black-cleartax.app.link/cTxO5GMgneb"
                  className="lil-btn lil-btn-link lil-items-center btn-text sm:lil-py-4"
                >
                  Download Black App
                  <span className="lil-font-medium">&nbsp; →</span>
                </a>
              </div>
              {/* {!this.state.isInputOpen && (
                  <button
                    onClick={this.props.openQRmodal}
                    className="lil-border-sm lil-btn lil-btn-link sm:lil-hidden"
                  >
                    Download black app
                  </button>
                )} */}
              {/* <button className="lil-font-bold">Download black app</button> */}
              {/* <img
                    src="http://cleartax-media.s3.amazonaws.com/cleartax/images/1632938935_vector.png"
                    alt=""
                    height="10"
                    width="10"
                  /> */}
            </div>
          </div>
          <div
            className={`${styles['imgContainer']} sm:lil-hidden`}
            // style={{width:"800px",height:"800px"}}
          >
            <GrowthIconDesktop />
          </div>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./components/homePageNew/growthSection/growthSection.tsx